/**
 * User Tier System
 *
 * Free tier: standard campaigns, limited count.
 * Paid tier: unlimited campaigns, Solo AI DM, LLM Deep co-DM.
 */
/** Free tier campaign ownership limit (null = unlimited) */
export const FREE_TIER_MAX_CAMPAIGNS = 3;
/** Alpha testers — bypass all tier restrictions. Single source of truth for client + server. */
export const ALPHA_EMAILS = ['brottler@gmail.com'];
export function getTierInfo(tier, email) {
    const isAlpha = !!email && ALPHA_EMAILS.includes(email.toLowerCase());
    if (tier === 'paid' || isAlpha) {
        return {
            tier: isAlpha && tier !== 'paid' ? 'free' : 'paid',
            isPaid: true,
            maxCampaigns: null,
            canUseSoloMode: true,
            canUseLLMDeep: true,
        };
    }
    return {
        tier: 'free',
        isPaid: false,
        maxCampaigns: FREE_TIER_MAX_CAMPAIGNS,
        canUseSoloMode: false,
        canUseLLMDeep: false,
    };
}
//# sourceMappingURL=tier-types.js.map